import { TransferRequestDetail } from "@/pages/requests/transfer/schema/transfer-requests.schema";
import { AppColors } from "@/styles/colors";
import { formatCurrency } from "@/utils/format-currency";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { CircleCheck, CircleX } from "lucide-react";

import "@/components/common/section-components/card/text-elements.css";
import { ScheduledTransferDetail } from "@/pages/requests/scheduled-transfer/schema/scheduled-transfer.schema";
import { ExternalTransferDetail } from "@/pages/requests/external-transfer/schema/external-transfer.schema";
import { ECheqRequestDetail } from "@/pages/requests/echeq/schema/echeq-requests.schema";
import dayjs from "dayjs";

interface Props {
  request?:
    | (
        | TransferRequestDetail
        | ScheduledTransferDetail
        | ExternalTransferDetail
        | ECheqRequestDetail
      )
    | null;
  scheduled?: boolean;
}

export const TransferRequestAmountAndActions = ({
  request,
  scheduled,
}: Props) => {
  return (
    <Flex justifyContent="space-between">
      <Grid templateColumns="repeat(3, 1fr)" gap="36px">
        {scheduled && (
          <GridItem>
            <Flex
              minH={"82px"}
              gap="10px"
              padding="12px"
              flexDir="column"
              borderRadius="12px"
              border={`1px solid ${AppColors.WHITE_BORDER_1}`}
            >
              <Text
                fontWeight={700}
                textTransform="uppercase"
                fontSize="12px"
                color={AppColors.GRAY_TEXT}
              >
                Fecha programada
              </Text>
              <Flex alignItems="center" gap="18px">
                <Text className={`requested-amount`}>
                  {dayjs(
                    (request as ScheduledTransferDetail | ExternalTransferDetail)
                      ?.fechaEjecucion,
                  ).format("DD/MM/YYYY")}
                </Text>
              </Flex>
            </Flex>
          </GridItem>
        )}
        <GridItem>
          <Flex
            minH={"82px"}
            gap="10px"
            padding="12px"
            flexDir="column"
            borderRadius="12px"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          >
            <Text
              fontWeight={700}
              textTransform="uppercase"
              fontSize="12px"
              color={AppColors.GRAY_TEXT}
            >
              Monto solicitado
            </Text>
            <Flex alignItems="center" gap="10px">
              <Flex alignItems="center" gap="8px">
                <Text className={`requested-amount`} fontSize={{
                  base: "15px",
                  sm: "15px",
                  md: "15px",
                  lg: "18px",
                  xl: "20px",
                }}>
                  ${formatCurrency(request?.montoSolicitado)}
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex
            minH={"82px"}
            gap="10px"
            padding="12px"
            flexDir="column"
            borderRadius="12px"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          >
            <Text
              fontWeight={700}
              textTransform="uppercase"
              fontSize="12px"
              color={AppColors.GRAY_TEXT}
            >
              Saldo
            </Text>
            <Flex alignItems="center" gap="10px">
              <Text
                fontSize={{
                  base: "15px",
                  sm: "15px",
                  md: "15px",
                  lg: "18px",
                  xl: "20px",
                }}
                className={`requested-amount`}
                color={
                  Number(request?.saldoActual) >= 0
                    ? AppColors.RED_ICON
                    : AppColors.GREEN_ICON
                }
              >
                ${formatCurrency(Math.abs(Number(request?.saldoActual)))}
              </Text>
              {request?.control ? (
                <CircleCheck
                  color={AppColors.GREEN_ICON}
                  data-testid="transfer-request-detail-circle-check-icon"
                />
              ) : (
                <CircleX
                  color={AppColors.RED_ICON}
                  data-testid="transfer-request-detail-circle-x-icon"
                />
              )}
            </Flex>
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
};
